import videojs from 'video.js';
import getIcon from "../templates/icon.svg.html";

const ClickableComponent = videojs.getComponent('ClickableComponent');

class Button extends ClickableComponent {
	constructor(player, options) {
		super(player, options);

		this.activeClassName = `${this.options_.className}_active`;
		this.$('.vjs-icon-placeholder').innerHTML = getIcon();
	}

	turnOn() {
		this.addClass(this.activeClassName);
	}

	turnOff() {
		this.removeClass(this.activeClassName);
	}

}

export { Button };
